<template>
  <v-container fluid>
    <left-drawer :mini_forced="mini" />
    <v-row v-if="!applicationReady">
      <v-col cols="12" class="page-container"> Loading ... </v-col>
    </v-row>
    <v-row v-if="applicationReady">
      <v-col cols="12" class="pa-0">
        <top-bar @mini-pressed="toggleDrawer" />
      </v-col>
      <v-col cols="12" class="page-container">
        <router-view></router-view>
      </v-col>
    </v-row>
  </v-container>
</template>

<script type="text/javascript">
import leftDrawer from './left-drawer';
import topBar from './top-bar';

export default {
  data() {
    return {
      mini: false,
    }
  },
  components: {
    leftDrawer,
    topBar,
  },
  created() {
    this.$store.dispatch('auth/userData');
  },
  computed: {
    applicationReady() {
      return this.$store.state.auth.users.loaded;
    },
  },
  methods: {
    toggleDrawer() {
      this.mini = !this.mini
    }
  }
};
</script>

<style lang="scss">
.page-container {
  background-color: $white-base;
  height: calc(100vh - 64px);
  overflow: auto;
}
</style>
